exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-overlay textarea.form-control {\r\n    height: auto;\r\n}\r\n\r\n.modal-overlay .vertical-alignment-helper {\r\n    margin-top: 18px;\r\n}\r\n\r\n.modal-dialog {\r\n    width: 800px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .modal-overlay .field-group .form-control,\r\n    .modal-overlay .field-group .field-item {\r\n        width: calc(100% - 135px);\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/common/EmailQuoteModal.css
// module id = 608
// module chunks = 0